import React, { useState } from "react";
import "./Forms.css";
import Questions from "../FormComponents/Questions";
import FormHeading, { ProgressBar, questionsList } from "../FormComponents/FormComponents";

export default function Personalization({ step, setStep }) {
  const questions = questionsList;
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);

  const progress = (currentQuestionIndex / questions.length) * 100;
  return (
    <>
      <FormHeading h3="Personalization"/>
      <div className="heading-inner">
        <h2>Select your primary focus areas</h2>
        <p>Highlight the areas you want to prioritize</p>
      </div>
      <ProgressBar progress={progress} />
      <div className="questions-wrapper">
        <Questions
          step={step}
          setStep={setStep}
          currentQuestionIndex={currentQuestionIndex}
          setCurrentQuestionIndex={setCurrentQuestionIndex}
        />
      </div>
    </>
  );
}
